export default "__VITE_PUBLIC_ASSET__3cacd379__"